/*
 * Appends the selected price to the main Add to cart label ("Add to cart — $41.00", Figma).
 * The cart form is the source of truth: its `id` (variant) and `selling_plan` inputs pick a
 * price from snippets/atc-price-data.liquid, so one-time / subscribe and variant changes are
 * followed whichever subscription widget writes those inputs. Lives in its own span because
 * product-form.js rewrites the button's first span on every submit.
 */
(() => {
  const init = (container) => {
    const form = container.querySelector('product-form form');
    const button = form?.querySelector('.product-form__submit');
    const data = container.querySelector('[data-atc-price-data]');
    if (!button || !data) return;

    const prices = JSON.parse(data.textContent);
    let label = button.querySelector('.atc-price-label');
    if (!label) {
      label = document.createElement('span');
      label.className = 'atc-price-label';
      button.append(label);
    }

    const update = () => {
      const formData = new FormData(form);
      const variantPrices = prices[formData.get('id')] || {};
      const price = variantPrices[formData.get('selling_plan') || ''] || variantPrices[''] || '';
      if (label.textContent !== price) label.textContent = price;
      label.hidden = !price || button.disabled;
    };

    // Widgets set input values from script (no change event), so watch the attributes too.
    new MutationObserver(update).observe(container, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['value', 'disabled'],
    });
    container.addEventListener('input', update);
    container.addEventListener('change', update);
    update();
  };

  document.querySelectorAll('.product__info-container').forEach(init);
})();
